<template>
    <div>
        <div class="reward-detail">
            <div style="display-inline;">
                <h3>Reward Detail</h3>
            </div>
            <div class="md-layout">
                <div class="md-layout-item md-size-30">
                    <img v-if="Info.image" :src="Info.image" width="100px">
                    <div v-else style="width:100p;height:100px;background:#ccc;margin-right:10px;"></div>
                </div>
                <div class="md-layout-item">
                    <ul class="items-details">
                        <li>
                            <strong class="data-head">Name</strong>
                            <span class="data-content">{{Info.name}}</span>
                        </li>
                        <li>
                            <strong class="data-head">Descriptoin</strong>
                            <span class="data-content">{{Info.description}}</span>
                        </li>
                        <li>
                            <strong class="data-head">Type</strong>
                            <span class="data-content">{{getType(Info.type)}}</span>
                        </li>
                        <li>
                            <strong class="data-head">Value</strong>
                            <span class="data-content">{{Info.value}}</span>
                        </li>
                        <li>
                            <strong class="data-head">In Stock</strong>
                            <span class="data-content">{{Info.in_stock}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
  name: "rewardInfo",
  props: ["Info"],
  data() {
    return {

        // dataInfo: this.Info
        //optionType: [{value:"Internal",title:"Goods of siamwalla"},{value:"External",title:"Non goods of siamwalla"}]
    };
  },
  methods:{
      getType(type){
        var data = [];
        data['Internal'] = "Goods of siamwalla";
        data['External'] = "Non Goods of siamwalla";
        return data[type];
      }
  }
};
</script>

<style lang="scss" scoped>
.items-details {
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    margin-bottom: 13px;
    display: flow-root;
  }

  .data-head {
    display: block;
    float: left;
    width: 90px;
  }
  .data-content {
    display: block;
    margin-left: 90px;
  }
}
</style>
